import { render, staticRenderFns } from "./CreateSurvey.vue?vue&type=template&id=b3e7b450&scoped=true&"
import script from "./CreateSurvey.vue?vue&type=script&lang=js&"
export * from "./CreateSurvey.vue?vue&type=script&lang=js&"
import style0 from "./CreateSurvey.vue?vue&type=style&index=0&id=b3e7b450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e7b450",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3e7b450')) {
      api.createRecord('b3e7b450', component.options)
    } else {
      api.reload('b3e7b450', component.options)
    }
    module.hot.accept("./CreateSurvey.vue?vue&type=template&id=b3e7b450&scoped=true&", function () {
      api.rerender('b3e7b450', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/CreateSurvey.vue"
export default component.exports